import React from 'react';
import { useTranslation } from 'react-i18next';

interface BasemapSelectionWrapperProps {
  children: React.ReactNode;
}

const BasemapSelectionWrapper = ({ children }: BasemapSelectionWrapperProps) => {
  const { t } = useTranslation('agisviewer');
  return (
    <div className="basemap-selection">
      <h2 className="tooldialog__subtitle">{t('basemap')}</h2>
      <div className="basemap-selection__container">{children}</div>
    </div>
  );
};

export default BasemapSelectionWrapper;
